import { FansUnitedSDK } from "fansunited-sdk-esm";
import { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import { API_KEY, CLIENT_ID } from "../api/constants";
import { getUserToken } from "../redux/user";
import { getUserLanguage } from "../redux/user/selectors";

function getTokenProvider(tokenId) {
	this.getIdToken = function () {
		return tokenId;
	};

	this.logout = function () {
		// Logout functionality handled by SDK
	};
}

const useFansUnitedSDK = () => {
	const [fansUnitedSDK, setFansUnitedSDK] = useState(null);

	const tokenId = useSelector(getUserToken);
	const language = useSelector(getUserLanguage);

	useEffect(() => {
		if (!tokenId) return;

		try {
			setFansUnitedSDK(
				FansUnitedSDK({
					apiKey: API_KEY,
					environment: "prod",
					clientId: CLIENT_ID,
					lang: language,
					idSchema: "native",
					errorHandlingMode: "default",
					authProvider: new getTokenProvider(tokenId),
					oddClient: {
						name: "betway",
						credentials: {
							username: "1595e515c03b86d29c803340ecf8009c",
							password: "64458644f5f1c95ec3b2135b4e4d9ea8",
						},
					},
				}),
			);
		} catch (error) {
			console.error("Failed to initialize Fans United SDK:", error);
			setFansUnitedSDK(null);
		}
	}, [tokenId, language]);

	return fansUnitedSDK;
};

export default useFansUnitedSDK;
